module.exports = __webpack_public_path__ + "static/media/S44_black.06f7afed.png";